// TODO: we should use colors from the Design System right?
/**
 * Colors used on svg charts
 * Our charts lib use d3js-scale `scaledOrdinal` to select
 * In each data point
 */
export const colorList = [
  '#2ACFBF', // turquoise
  '#FF742F', // orange
  '#DCCFBA', // shellBeige
  '#FF4853', // coral
  '#009F57', // happyGreen
  '#FFBC00', // zinniaYellow
  '#A5CCEB', // pastelBlue
  '#B78E64', // coffee
  '#5A672E', // cedarGreen
  '#1F5278', // blueJean
  '#756D61', // driftwood
  '#2E3850', // navy
  '#D11E23', // wine
  '#BCA000', // oliveOil
  '#FF9C6E', // cantaloupe
  '#FEC8C8', // blushPink
  '#D3D9DE', // lightGrey
  '#81E2BB', // mint
  '#5E433C', // oak
  '#D1B386', // sand
]

export const UIColors = {
  legendColor: '#A8AFB3',
  tickColor: '#1C242B',
  brand: '#695EE8',
  grey3: '#A8AFB3',
}
